import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { catchError, map, tap } from 'rxjs';

import { CourtService } from '@shared/services/court.service';
import { ProbateService } from '@app/probate/shared/services/probate.service';

export const probateContextGuard: CanActivateFn = () => {
  const probateService = inject(ProbateService);
  const courtService = inject(CourtService);

  const targetId = probateService.targetProbateId();
  const currentProbate = probateService.probate();
  const probateId = targetId || currentProbate?.id;

  if (!probateId) throw new Error();

  return probateService
    .getProbateDetail(Number(courtService.courtId()), Number(probateId))
    .pipe(
      tap(() => probateService.clearTargetProbateId()),
      map((probate) => !!probate),
      catchError(() => {
        throw new Error();
      }),
    );
};
